/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RowData } from './rowData';

/**
 * FiatDepositInstruction DTO
 */
export interface FiatDepositInstructionDto {
  name: string;
  nameForClient: string;
  assetId: number;
  data: Array<RowData>;
  id: number;
  businessEntity: FiatDepositInstructionDto.BusinessEntityEnum;
}
export namespace FiatDepositInstructionDto {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
